/**
 * BasicInfoSection Component
 * 라이더 기본정보 섹션
 */
import React from 'react';
import { RiderDetailInfo } from '../types/riderInfoDetail.types';
import {
    BASIC_INFO_LEFT_FIELDS,
    BASIC_INFO_RIGHT_FIELDS,
    getDisplayValue,
    formatSettlementDate
} from '../lib/riderInfoDetailHelpers';
import { getPreAccountBadgeText } from '@/shared/utils/accountingLabelHelpers';

interface BasicInfoSectionProps {
    riderInfo: RiderDetailInfo;
}

const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({ riderInfo }) => {
    const renderFieldValue = (key: string): string => {
        if (key === 'preAcctYn') {
            return getPreAccountBadgeText(riderInfo.preAcctYn || null);
        }

        if (key === 'currentSettlement') {
            const typeName = riderInfo.acctApplyTypeName || '-';
            const date = formatSettlementDate(riderInfo.acctApplyDay);
            return date !== '-' ? `${typeName} (${date})` : typeName;
        }

        if (key === 'nextSettlement') {
            const typeName = riderInfo.nextAcctApplyTypeName || '-';
            const date = formatSettlementDate(riderInfo.nextAcctApplyDay);
            return date !== '-' ? `${typeName} (${date})` : typeName;
        }

        const value = riderInfo[key as keyof RiderDetailInfo];
        return getDisplayValue(value as string | undefined);
    };

    return (
        <div className="section-margin">
            <h3 className="section-title">기본정보</h3>
            <div className="basic-info-container">
                <div className="basic-info-grid">
                    <div className="basic-info-column">
                        {BASIC_INFO_LEFT_FIELDS.map((field) => (
                            <div key={field.key} className="basic-info-row">
                                <div className="basic-info-label">{field.label}:</div>
                                <div>{renderFieldValue(field.key)}</div>
                            </div>
                        ))}
                    </div>

                    <div className="basic-info-column">
                        {BASIC_INFO_RIGHT_FIELDS.map((field) => (
                            <div key={field.key} className="basic-info-row">
                                <div className="basic-info-label">{field.label}:</div>
                                <div className={
                                    field.key === 'currentSettlement' || field.key === 'nextSettlement'
                                        ? 'settlement-info-value'
                                        : ''
                                }>
                                    {renderFieldValue(field.key)}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BasicInfoSection;
